<script>
  import { onMount, getContext } from "svelte";
  import tippy from "tippy.js";
  import "tippy.js/dist/tippy.css";

  export let abbr;
  export let menu = [];

  let el;
  let contentEl;
  let tippiInstance;

  onMount(() => {
    tippiInstance = tippy(el, {
      content: contentEl,
      allowHTML: true,
      interactive: true,
      trigger: "click",
      theme: "ticketco-ticketbuyer-profile",
    });

    return () => tippiInstance.destroy();
  });
</script>

<style>
  :global(.tippy-box[data-theme~="ticketco-ticketbuyer-profile"]) {
    background-color: #f2f2f2;
    background-color: var(--main-inner-card-background-color, #f2f2f2);
    border-radius: 6px;
    border-radius: var(--main-border-radius, 6px);
    box-shadow: 0 0 5px rgba(128, 128, 128, 0.7);
  }
  :global(
      .tippy-box[data-theme~="ticketco-ticketbuyer-profile"] .tippy-content
    ) {
    padding: 0.75rem 0;
  }
  :global(
      .tippy-box[data-theme~="ticketco-ticketbuyer-profile"][data-placement^="top"]
        > .tippy-arrow::before
    ) {
    border-top-color: #f2f2f2;
    border-top-color: var(--main-inner-card-background-color, #f2f2f2);
  }
  :global(
      .tippy-box[data-theme~="ticketco-ticketbuyer-profile"][data-placement^="bottom"]
        > .tippy-arrow::before
    ) {
    border-bottom-color: #f2f2f2;
    border-bottom-color: var(--main-inner-card-background-color, #f2f2f2);
  }
  :global(
      .tippy-box[data-theme~="ticketco-ticketbuyer-profile"][data-placement^="left"]
        > .tippy-arrow::before
    ) {
    border-left-color: #f2f2f2;
    border-left-color: var(--main-inner-card-background-color, #f2f2f2);
  }
  :global(
      .tippy-box[data-theme~="ticketco-ticketbuyer-profile"][data-placement^="right"]
        > .tippy-arrow::before
    ) {
    border-right-color: #f2f2f2;
    border-right-color: var(--main-inner-card-background-color, #f2f2f2);
  }
</style>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  stroke="currentColor"
  aria-hidden="true"
  class="w-6 h-6 text-headerForeground">
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
</svg>

<button
  type="button"
  class="tracking-tighter bg-headerForeground group-hover:-rotate-12 flex shadow items-center justify-center w-9 h-9 rounded-full text-headerBackground font-semibold transition duration-400 ease-in-out uppercase"
  bind:this={el}>
  {#if abbr}
    {abbr}
  {:else}
    <svg
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
    </svg>
  {/if}
</button>

<div class=" w-56" bind:this={contentEl} data-no-turbolink>
  <div class="flex flex-col">
    {#each menu as { type, data, href, title }}
      {#if type === "link"}
        <a
          {href}
          class="text-mainInnerCardForeground hover:bg-mainInnerCardForeground/10 px-4 py-3 text-base truncate"
          >{title}</a>
      {:else if type === "summary"}
        <div class="px-4 py-1">
          <div class="text-mainInnerCardForeground text-base truncate">
            {data[0]}
          </div>
          <div
            class="text-xs text-mainInnerCardForeground/60 truncate"
            title={data[1]}>
            {data[1]}
          </div>
        </div>
      {:else if type === "delimiter"}
        <hr class="border-mainInnerCardForeground/10 my-2 mx-4" />
      {/if}
    {/each}
  </div>
</div>
